import React from 'react'
import { WemoloButton, WemoloCrossIcon, WemoloTextLink, WemoloTypography } from '../../../../components/Wemolo'
import { useDetectionExplorerStore } from '../../DetectionExplorerStore'
import { DETECTION_EXPLORER_TEXT } from '../../config'
import { FilterChipContainer } from './FilterChipContainer'
import styles from './ActiveFilters.module.css'

const IMAGE_REQUESTS_TEXT = DETECTION_EXPLORER_TEXT.imageRequests

export const ActiveFiltersContainer = () => {
    const activeFilters = useDetectionExplorerStore((s) => s.activeFilters)
    const clearActiveFilters = useDetectionExplorerStore((s) => s.clearActiveFilters)
    const appliedImageRequestId = useDetectionExplorerStore((s) => s.appliedImageRequestId)
    const clearAppliedImageRequest = useDetectionExplorerStore((s) => s.clearAppliedImageRequest)

    if (activeFilters.length === 0 && !appliedImageRequestId) return null

    return (
        <>
            {appliedImageRequestId && (
                <span className={styles.chip}>
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.label}>
                        {IMAGE_REQUESTS_TEXT.appliedLabel}
                    </WemoloTypography>
                    <span title={appliedImageRequestId}>
                        <WemoloTypography variant="label-xsmall" tag="span">
                            {appliedImageRequestId.slice(0, 8)}
                        </WemoloTypography>
                    </span>
                    <WemoloButton
                        view="ghost"
                        size="small"
                        icon={<WemoloCrossIcon />}
                        onClick={clearAppliedImageRequest}
                        aria-label={IMAGE_REQUESTS_TEXT.clearApplied}
                        className={styles.removeButton}
                    />
                </span>
            )}
            {activeFilters.map((instance) => (
                <FilterChipContainer key={instance.id} instance={instance} />
            ))}
            {activeFilters.length > 0 && (
                <WemoloTextLink size="small" onClick={clearActiveFilters}>
                    {DETECTION_EXPLORER_TEXT.filters.clearAll}
                </WemoloTextLink>
            )}
        </>
    )
}
